export default __webpack_public_path__ + "static/media/anexo_armado_respiradores.7531c9e8.pdf";